import {
  PieChart as RPieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { CHART_COLORS } from '../../config/constants';
import { useChartTheme } from '../../hooks/useChartTheme';

// data: [{ name, total }]. Renders a donut. onSliceClick(name) fires when a slice
// is clicked (cursor becomes a pointer when the handler is provided).
export function PieChart({ data, height = 280, onSliceClick, showLegend = true }) {
  const ct = useChartTheme();
  const grandTotal = (data || []).reduce((s, d) => s + (Number(d.total) || 0), 0);
  return (
    <div className="relative" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <RPieChart>
          <Pie
            data={data}
            dataKey="total"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={58}
            outerRadius={95}
            paddingAngle={2}
            stroke="none"
            onClick={onSliceClick ? (d) => onSliceClick(d?.name) : undefined}
            cursor={onSliceClick ? 'pointer' : 'default'}
          >
            {data?.map((_, i) => <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />)}
          </Pie>
          <Tooltip
            contentStyle={ct.tooltip}
            itemStyle={{ color: ct.tooltip.color }}
            labelStyle={{ color: ct.tooltip.color }}
            formatter={(v) => {
              const n = Number(v);
              const pct = grandTotal ? ((n / grandTotal) * 100).toFixed(1) : '0.0';
              return [`${n.toLocaleString()} (${pct}%)`, 'Usage'];
            }}
          />
          {showLegend && <Legend wrapperStyle={{ fontSize: 12 }} />}
        </RPieChart>
      </ResponsiveContainer>
      {/* Center total (donut hole) — aligns when no built-in legend is shown. */}
      {!showLegend && grandTotal > 0 && (
        <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-lg font-bold text-navy-800 dark:text-slate-100">{grandTotal.toLocaleString()}</span>
          <span className="text-xs text-slate-400 dark:text-slate-500">Total</span>
        </div>
      )}
    </div>
  );
}
